export default __webpack_public_path__ + "static/media/card-4.a4ac034f.jpeg";